import React, {Component} from "react";
import { connect } from "react-redux";
import { Table } from "reactstrap";
import { createFilter } from 'react-search-input';
import { GetWorkorderList, GetPreventativeMaintenanceList } from "../../../../../action/workorderAction";
import LoadingIndicator from '../../../Common/LoadingIndicator';

const KEYS_TO_FILTERS = ['serialNumber', 'technicianName', 'pastDueDate'];
class WOColumnBarChart extends Component{
    
    componentWillMount(){
        if(this.props.WorkOrderList !== null && this.props.WorkOrderList !== undefined){
            if(this.props.PMList !== null && this.props.PMList !== undefined){
                this.setState({isloading: false});   
            }
            else{
                this.props.GetPreventativeMaintenanceList().then(() => {
                this.setState({isloading: false});
                });
            }
                    
        }

        else{
            this.props.GetWorkorderList().then(() => this.props.GetPreventativeMaintenanceList().then(() => 
            this.setState({isloading: false}))
            ); 
        }
    }

    componentWillReceiveProps(nextProps){
        if (this.props !== nextProps) {
            var Records = [], FormattedWOData = [], FormattedPMData = [];
            let WOData = (nextProps.WorkOrderList !== null && nextProps.WorkOrderList !== undefined && nextProps.WorkOrderList.length > 0) ? nextProps.WorkOrderList : nextProps.getList.WorkOrderList;
            let PMData = (nextProps.PMList !== null && nextProps.PMList !== undefined && nextProps.PMList.length > 0) ? nextProps.PMList : nextProps.getList.PreventativeMaintenanceList;

            if (WOData !== null && WOData !== undefined && WOData.length > 0) {
                var WOPastDueData = WOData.filter(x => x.status !== 6 && x.isDueDatePassed === true && x.dueDate !== '1753-01-01T00:00:00');
                WOPastDueData.forEach(el => {
                    var TechnicianName = '';
                    if (this.props.getTechnicianList !== undefined && this.props.getTechnicianList.length) {
                        var TechName = this.props.getTechnicianList.filter(ele => ele.technicianID === el.assignedUserID)
                        TechnicianName = (TechName[0] !== undefined && TechName[0] !== null) ? TechName[0].name : '';
                    }
                    var Data = {
                        "serialNumber" : el.serialNumber,
                        "id" : el.workOrderID,
                        "assignedTo" : el.assignedUserID,
                        "dueDate" : el.dueDate,
                        "pastDueDate" : new Date(el.dueDate).toDateString(),
                        "technicianName": TechnicianName
                    }
                    Records.push(Data);
                    FormattedWOData.push(Data);
                });
            }
            
            if (PMData !== null && PMData !== undefined && PMData.length > 0) {
                var PMPastDueData = PMData.filter(x => x.status !== 6 && x.isDueDatePassed === true && x.dueDate !== '1753-01-01T00:00:00' && x.dueDate !== '0001-01-01T00:00:00');
                PMPastDueData.forEach(el => {
                    var TechnicianName = '';
                    if (this.props.getTechnicianList !== undefined && this.props.getTechnicianList.length) {
                        var TechName = this.props.getTechnicianList.filter(ele => ele.technicianID === el.assignedTo)
                        TechnicianName = (TechName[0] !== undefined && TechName[0] !== null) ? TechName[0].name : '';
                    }
                    var Data = {
                        "serialNumber" : el.serialNumber,
                        "id" : el.id,
                        "assignedTo" : el.assignedTo,
                        "dueDate" : el.dueDate,
                        "pastDueDate" : new Date(el.dueDate).toDateString(),
                        "technicianName": TechnicianName
                    }
                    Records.push(Data);
                    FormattedPMData.push(Data);
                });
            }

            this.setState({ Mergedlist : Records, WOlist : FormattedWOData, PMlist : FormattedPMData });
        }
    }

    constructor(props){
        super(props);
        this.state = {
            isloading: true,
            WOlist: [],
            PMlist: [],
            Mergedlist : [],
            sort: {
                column: null,
                direction: [
                    { name: 'serialNumber', direction: 'desc', onclick: false },
                    { name: 'technicianName', direction: 'desc', onclick: false },
                    { name: 'dueDate', direction: 'desc', onclick: true }
                ]
            },
            searchTerm : "",
            IsDefaultSort : true
        };
        this.searchUpdated = this.searchUpdated.bind(this);
    }

    /* Search System */
    searchUpdated(term) {
        this.setState({ searchTerm: this.refs.kpiboard_search_value.value })
    }

    /* Sorting  System */
    onSortNumber = (column) => (e) => {
        this.setState({ IsDefaultSort: false });
        var SortData = this.state.sort.direction;
        var selected = SortData.filter(a => a.name === column);
        const direction = selected[0] ? (selected[0].direction === 'asc' ? 'desc' : 'asc') : 'asc';
        var WOdata_from_state = this.state.WOlist;
        var PMdata_from_state = this.state.PMlist;
        if (WOdata_from_state !== null) {
            const sortedData = WOdata_from_state.sort((a, b) => {
                let nameA, nameB;
                nameA = a["id"];
                nameB = b["id"];
                return (nameA - nameB);
            });
            if (direction === 'desc') {
                sortedData.reverse();
            }

            const sortedData1 = PMdata_from_state.sort((a, b) => {
                let nameA, nameB;
                nameA = a["id"];
                nameB = b["id"];
                return (nameA - nameB);
            });
            if (direction === 'desc') {
                sortedData1.reverse();
            }

            if (selected[0].name === "serialNumber") {
                SortData[0].direction = direction;
                const array = this.state.sort.direction;
                array.map(x => (x.name !== "serialNumber") ? x.onclick = false : x.onclick = true);
                this.setState({ SortData: array });
            }

            var MergedData = (direction === 'desc') ? sortedData.concat(sortedData1) : sortedData1.concat(sortedData);
            this.setState({
                Mergedlist: MergedData,
                sort: {
                    column,
                    direction: SortData,
                }
            });
        }
    };

    onSort = (column) => (e) => {
        this.setState({ IsDefaultSort: false });
        var SortData = this.state.sort.direction;
        var selected = SortData.filter(a => a.name === column);
        const direction = selected[0] ? (selected[0].direction === 'asc' ? 'desc' : 'asc') : 'asc';
        var data_from_state = this.state.Mergedlist;
        var notequals = 0;

        if (data_from_state !== null) {
            const sortedData = data_from_state.sort((a, b) => {
                let nameA, nameB;
                nameA = a[column];
                nameB = b[column];

                if (nameA < nameB) {
                    notequals = 1;
                    return -1;
                }
                if (nameA > nameB) {
                    notequals = 1;
                    return 1;
                }
                if (nameA === nameB) {
                    return 0;
                }
                return 0;
            });

            if (selected[0].direction === 'asc' && notequals === 1) {
                sortedData.reverse();
            }

            if (selected[0].name === "technicianName") {
                SortData[1].direction = direction;
                var array = this.state.sort.direction;
                array.map(x => (x.name !== "technicianName") ? x.onclick = false : x.onclick = true);
                this.setState({ SortData: array });
            }
            if (selected[0].name === "dueDate") {
                SortData[2].direction = direction;
                var array1 = this.state.sort.direction;
                array1.map(x => (x.name !== "dueDate") ? x.onclick = false : x.onclick = true);
                this.setState({ SortData: array });
            }

            this.setState({
                Mergedlist: sortedData,
                sort: {
                    column,
                    direction: SortData,
                }
            });
        }
    };
  
    render(){
        let label = this.props.getLabels;
        let PastDueRecords = [];  
        let data_from_state = this.state.Mergedlist;
        let preferredfields = this.props.getWorkorderPreferences;
       
        var assignedto = preferredfields !== undefined && preferredfields !== "" ? preferredfields.filter(x => x.field === "Assigned To" && x.display === true) : '';
        if (this.state.IsDefaultSort){
            if (data_from_state !== null) {
                const sortedData = data_from_state.sort((a, b) => {
                    let nameA, nameB;
                    nameA = a["dueDate"];
                    nameB = b["dueDate"];
    
                    if (nameA < nameB) {
                        return -1;
                    }
                    if (nameA > nameB) {
                        return 1;
                    }
                    if (nameA === nameB) {
                        return 0;
                    }
                    return 0;
                });
                data_from_state = sortedData.reverse();
            }
        }

        let FilteredData = data_from_state.filter(createFilter(this.state.searchTerm, KEYS_TO_FILTERS));
        if (FilteredData !== null && FilteredData !== undefined && FilteredData.length > 0 && !this.state.isloading) {
            PastDueRecords = FilteredData.map(el => (
                <tr key={el.serialNumber}>
                    <td width="25%"><p className="link_cursor" style={{ color: '#6890C6' }} onClick={() => {this.props.redirect_WO_PM_Details(el.id,el.serialNumber)}}>{el.serialNumber}</p></td>
                    <td width="40%">{el.technicianName !== "" ? el.technicianName : <b>---</b>}</td>
                    <td width="35%">{el.pastDueDate}</td>
                </tr>
            ));
        }else if(!this.state.isloading){
            PastDueRecords = <tr><td colSpan="3">{label['WorkOrders.Table.Default.Text']}</td></tr>
        } else{
            PastDueRecords = <tr><td colSpan="3" style={{textAlign: 'center'}}><LoadingIndicator/></td></tr>
        }

        return (
            <div className="main_container box_border">
                <label style={{ fontFamily: 'lato', fontSize: '15px', fontWeight: 'bold', color: 'black' }}>Past Due Records</label><br />
                <div className="row row_padding" style={{marginLeft:'0px',marginRight:'0px'}}>
                    <div className="col-md-12" style={{paddingTop:'11px',paddingBottom:'11px',paddingRight:'0px'}}>
                        <span className="pm_outersearchbox" style={{ float: 'right' }}>
                            <input type="text" className="pm_searchbox" style={{ paddingLeft: '10px', marginTop: '3px' }} placeholder="Enter Value..." onChange={this.searchUpdated} ref='kpiboard_search_value' id="kpi_due_search" />
                        </span>
                        <label style={{ fontFamily: 'lato', fontSize: '13px', fontWeight: 'bold', color: 'black', float: 'right', marginTop: '4px' }}>{"Search:"}</label>
                    </div>
                </div>
                <div className="table_container table_border" style={{marginBottom:'0px'}}>
                    <Table striped responsive className="Custom_table fixed_layout" id="kpi_pastdue_table" >
                        <thead className="cell_container_header">
                            <tr>
                                <th width="25%" className="wo_cursor" onClick={this.onSortNumber('serialNumber')}>{"Record#"}
                                    <span className={(this.state.sort.direction[0].name === "serialNumber") ?
                                        (this.state.sort.direction[0].onclick) ? (this.state.sort.direction[0].direction === "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                            : (this.state.sort.direction[0].direction === "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                    </span>
                                </th>
                                <th width="40%" className="wo_cursor" onClick={this.onSort('technicianName')} >{assignedto.length > 0 ? assignedto[0].fieldLabel : "Assigned To"}
                                    <span className={(this.state.sort.direction[1] !== undefined && this.state.sort.direction[1].name === "technicianName") ?
                                        (this.state.sort.direction[1].onclick) ? (this.state.sort.direction[1].direction === "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                            : (this.state.sort.direction[1].direction === "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                    </span>
                                </th>
                                <th width="35%" style={{paddingLeft:'3px'}} className="wo_cursor" onClick={this.onSort('dueDate')}>{"Scheduled Date/Due Date"}
                                    <span className={(this.state.sort.direction[2] !== undefined && this.state.sort.direction[2].name === "dueDate") ?
                                        (this.state.sort.direction[2].onclick) ? (this.state.sort.direction[2].direction === "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                            : (this.state.sort.direction[2].direction === "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                    </span>
                                </th> 
                            </tr>
                        </thead>
                        <tbody className="cell_container kpi_table_tbody cell_container_body">
                            {PastDueRecords}
                        </tbody>
                    </Table>
                </div>
            </div>
        )
    }
}
const mapStateToProps = state => {
    return {
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference,
        getList: state.WorkorderRootReducer,
        getTechnicianList: state.WorkorderRootReducer.Technicians,
        getWorkorderPreferences: state.authService.workorder_user_preferencedetails
    };
};
const mapDispatchToProps = dispatch => {
    return {
        GetWorkorderList: () => dispatch(GetWorkorderList()),
        GetPreventativeMaintenanceList: () => dispatch(GetPreventativeMaintenanceList())
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(WOColumnBarChart);